import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { ListTemplateCategoriesV2, ListTemplateCategoriesV2Variables } from './__generated__/ListTemplateCategoriesV2'

const QUERY = gql`
  query ListTemplateCategoriesV2($input: ListTemplateCategoriesInputV2!) {
    listColorTemplates: listTemplateCategoriesV2(input: $input) {
      templateCategories {
        id
        title
      }
    }
  }
`

export const useListColorTemplates = (variables: ListTemplateCategoriesV2Variables) => {
  return useQuery<ListTemplateCategoriesV2, ListTemplateCategoriesV2Variables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables
  })
}
